import type { ComponentProps } from 'react';
import React from 'react';
import type { ViewProps } from 'react-native';

import { BodyText } from '../Text';
import { getProductIngredientsList } from './ProductIngredientsList.utils';

// ────────────────────────────────────────────────────────────────────────────────

export const ProductIngredientsList = (props: ProductIngredientsListProps) => {
  const {
    addedIngredients = [],
    addedIngredientsLabel = 'Add:',
    addedIngredientsListTestID,
    removedIngredients = [],
    removedIngredientsLabel = 'Remove:',
    removedIngredientsListTestID,
    textSize,
  } = props;

  return (
    <>
      {addedIngredients.length > 0 ? (
        <IngredientsList
          ingredients={addedIngredients}
          label={addedIngredientsLabel}
          testID={addedIngredientsListTestID}
          textSize={textSize}
        />
      ) : null}

      {removedIngredients.length > 0 ? (
        <IngredientsList
          ingredients={removedIngredients}
          label={removedIngredientsLabel}
          testID={removedIngredientsListTestID}
          textSize={textSize}
        />
      ) : null}
    </>
  );
};

// ─── SUBCOMPONENTS ──────────────────────────────────────────────────────────────

const IngredientsList = (props: LineItemIngredientsListProps) => {
  const { ingredients = [], label, testID, textSize = 4 } = props;

  if (ingredients.length === 0) return null;

  const formattedIngredients = getProductIngredientsList(ingredients);

  return (
    <BodyText size={textSize} testID={testID}>
      {label} {formattedIngredients}
    </BodyText>
  );
};

// ─── TYPES ──────────────────────────────────────────────────────────────────────

type ProductIngredientsListProps = {
  readonly addedIngredients?: Ingredients;
  readonly addedIngredientsLabel?: string;
  readonly addedIngredientsListTestID?: ViewProps['testID'];
  readonly removedIngredients?: Ingredients;
  readonly removedIngredientsLabel?: string;
  readonly removedIngredientsListTestID?: ViewProps['testID'];
  readonly textSize?: LineItemIngredientsListProps['textSize'];
};

type LineItemIngredientsListProps = {
  readonly label: string;
  readonly ingredients: Ingredients;
  readonly testID?: ViewProps['testID'];
  readonly textSize?: ComponentProps<typeof BodyText>['size'];
};

type Ingredients = ReadonlyArray<{
  readonly name?: string;
}>;
